import { api } from "../../../components/utils/JWTAuth";
import React, { Component } from "react";
//import { Link } from 'react-router-dom';
import TopImageTitle from "../../objects/topImageTitle";
import SEO from "../../objects/seo";
import { Col, Row, Container } from "react-grid-system";
import { Redirect, Link } from "react-router-dom";
import NoticiaResume from "../../objects/noticiaResume";
//import { Pagination } from "antd";
import ReactGA from "react-ga";
import { Pagination } from "antd";
class NoticesTemplate01 extends Component {
	constructor(props) {
		super();
		this.state = {
			array_post: props.array_post,
			array_page: props.array_page,
			filterCat: [],
			categories: [],
			news: [],
			page: [],
			statusPage: 0,
			currentPage: 1,
			todosPerPage: 12,
			years: [],
			activeId: null,
			newsFetching: false,
			minValue: 0,
			maxValue: 9,
			current: 1,
			currentTodos: [],
			_news: [],
		};
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick(event) {
		this.setState({
			currentPage: Number(event.target.id),
		});
	}
	changeFilterCat = (e) => {
		//var catSelected = e.target.value;
		const wanted = [e.target.value];
		var GoodNews = [];
		this.state.news.map((ne, index) => {
			var idcat = ne.categories.map((categories) => categories.id);

			if (wanted.some((r) => idcat.includes(r))) {
				GoodNews.push(ne);
				return null;
			} else {
				//GoodNews.push(ne);
				return null;
			}
		});

		let _news = GoodNews;
		/*if (catSelected) {
			_news = _news.filter(
				(item) =>
					+item.categories.map((categories) => categories.id) === +catSelected
			);
		}*/

		this.setState({
			filterCat: e.target.value,
			minValue: 0,
			maxValue: 9,
			current: 1,
			activeId: e.target.value,
			_news: e.target.value === "" ? this.state.news : _news,
		});
	};

	getNewsCurrentYear = async () => {
		this.setState({
			newsFetching: true,
		});

		let res = await api.get("/news_get_by_last_year");
		this.setState({
			news: res.data.records,
			_news: res.data.records,
			newsFetching: false,
		});
	};
	getYears = async () => {
		let res = await api.get("/news_get_years");
		this.setState({
			years: res.data.records.reverse(),
		});
	};
	getCategories = async () => {
		let res = await api.get("/get_all_categories");
		this.setState({
			categories: res.data.records,
		});
	};
	componentDidMount() {
		//Call to webservice to get the new
		(async () => {
			await this.getCategories();
			await this.getYears();
			await this.getNewsCurrentYear();
		})();
		ReactGA.pageview(window.location.pathname + window.location.search);
	}
	handleChange = (value) => {
		if (value <= 1) {
			this.setState({
				minValue: 0,
				maxValue: 9,
				current: 1,
			});
		} else {
			this.setState({
				minValue: value * 9 - 9,
				maxValue: value * 9,
				current: value,
			});
		}
	};

	render() {
		const { statusPage } = this.state;
		if (statusPage === 1) {
			return <Redirect to="/404" />;
		}
		const { years } = this.state;
		//const { news } = this.state;

		//	const { currentPage, todosPerPage } = this.state;
		//let news = this.state.news;
		//const indexOfLastTodo = currentPage * todosPerPage;
		const { array_post } = this.state;
		//const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
		const { categories } = this.state;

		//const currentTodos = _news.slice(indexOfFirstTodo, indexOfLastTodo);
		const yearList = years.map((year) => {
			return (
				<li key={year.year}>
					<Link to={"/historico-noticias/" + year.year}>{year.year}</Link>
				</li>
			);
		});
		const notWantedCategories = global.notWantedCategoriesNews;
		var catCount = 0;
		const categoriesList = categories.length ? (
			categories
				/* .sort(
					(a, b) =>
						(+a.order_cat === 0) - (+b.order_cat === 0) ||
						+(+a.order_cat > +b.order_cat) ||
						-(+a.order_cat < +b.order_cat)
				) */
				.sort(
					(a, b) => a.order_cat - b.order_cat
				)
				.map((categories) => {
					if (categories.id && Array.isArray(categories.id) && notWantedCategories.some((r) => categories.id.includes(r))) {
						return null;
					} else {
						catCount++;
						return (
							<Col
								lg={4}
								sm={6}
								key={categories.id}
								className={"categories-button category-" + categories.id}
							>
								<button
									className={
										"filterCategories " +
										(this.state.activeId === categories.id && "button")
									}
									onClick={this.changeFilterCat}
									value={categories.id}
								>
									{categories.name}
								</button>
							</Col>
						);
					}
				})
		) : (
			<div className="center">No hay categorias</div>
		);

		const newsList = this.state._news
			.slice(+this.state.minValue, +this.state.maxValue)
			.map((news, index) => {
				var idcat = news.categories.map((categories) => categories.id);
				if (
					notWantedCategories.some((r) => idcat.includes(r)) ||
					idcat.length < 1
				) {
					return null;
				} else {
					return (
						<Col
							lg={4}
							sm={6}
							key={news.id}
							className={
								"new-cat d-flex category-filter category-" +
								news.categories.map((categories) => categories.id)
							}
						>
							<NoticiaResume
								key={index}
								title={news.title}
								img={news.cover_image}
								categories={news.categories}
								link={news.permalink}
								short_description={news.short_description}
								date={news.published_date}
								meta_description={news.meta_description}
							></NoticiaResume>
						</Col>
					);
				}
			});
		/*
		const pageNumbers = [];
		for (let i = 1; i <= Math.ceil(_news.length / todosPerPage); i++) {
			pageNumbers.push(i);
		}
		const renderPageNumbers = pageNumbers.map((number) => {
			return (
				<span key={number} id={number} onClick={this.handleClick}>
					{number}
				</span>
			);
		});*/
		const title = array_post.map((post, index) => {
			return (
				<TopImageTitle
					key={index}
					key_id={post.id}
					title={post.title}
					cover_image={post.img}
					subtitle={post.subtitle}
					bread01={post.title}
					id_parentMenu={!post.id_menu ? null : post.id_menu}
				></TopImageTitle>
			);
		});

		const MetaTagsSeo = array_post.map((post) => {
			return (
				<SEO
					title={!post.meta_title ? post.title : post.meta_title}
					description={post.meta_description}
					keywords={post.keywords}
					cover_image={post.img}
					key={"SEO" + post.id}
				></SEO>
			);
		});

		return (
			<div>
				{MetaTagsSeo}
				{title}
				<hr className="whiteSpace"></hr>
				<Container>
					<Row className="categoryBlock">
						<Col lg={9} sm={12}>
							<Row>
								<Col sm={12}>
									<h5 className="center">Selecciona una categoría</h5>
								</Col>{" "}
								{catCount <= 1 ? null : categoriesList}
							</Row>
							{catCount <= 1 ? null : (
								<Row>
									<Col lg={4} sm={2}>
										<hr></hr>
									</Col>
									<Col lg={4} sm={8} className={"categories-button category-"}>
										<button
											className={"filterCategories cleanFilter false "}
											onClick={this.changeFilterCat}
											value={""}
										>
											Ver todas las categorias
										</button>
									</Col>
									<Col lg={4} sm={2}>
										<hr></hr>
									</Col>
								</Row>
							)}
							<Row className="hideInDesktop">
								<Col lg={12} sm={12}>
									<h4 className="center" style={{ marginTop: "10px" }}>
										Buscador
									</h4>
									<form
										className="formSearchSlider"
										action="/buscador"
										method="GET"
									>
										<div className="searchSlider">
											<input
												className="searchBarHome width-100 searchInNews"
												type="text"
												placeholder=""
												name="s"
												autoComplete="off"
											/>
											<br></br>
											<input
												className="button width-100"
												type="submit"
												value="Buscar"
											/>
										</div>
									</form>
								</Col>
							</Row>
							<Row className="listCategory">{newsList}</Row>
							<div className="center">
								<div id="page-numbers">{/*renderPageNumbers*/}</div>
							</div>

							<div>
								<Pagination
									key={this.state._news}
									defaultCurrent={1}
									current={this.state.current}
									pageSize={9}
									onChange={this.handleChange}
									total={this.state._news.length}
								/>
							</div>
						</Col>
						<Col lg={3} sm={12}>
							<h2>Buscador</h2>
							<form
								className="formSearchSlider"
								action="/buscador"
								method="GET"
							>
								<div className="searchSlider">
									<input
										className="searchBarHome width-100 searchInNews"
										type="text"
										placeholder=""
										name="s"
										autoComplete="off"
									/>
									<br></br>
									<input
										className="button width-100"
										type="submit"
										value="Buscar"
									/>
								</div>
							</form>
							<h2>Histórico</h2>
							<div className="yearSidebar">
								<ul>{yearList}</ul>
							</div>
							<h2>Enviar Noticia</h2>
							<div className="yearSidebar">
								<a href="/enviar-noticia-FES" className="button width-100">
									Formulario
								</a>

								<a
									href="https://fes-sociologia.com/paginas/canal-de-noticias-fes"
									className="width-100"
								>
									Criterios de publicación
								</a>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}
export default NoticesTemplate01;
